import styled from '@emotion/styled';
import { COLORS, mediaMax, breakpoints } from 'styles';

export const Wrapper = styled.div`
  height: max-content;
  padding-bottom: 74px;

  ${mediaMax(breakpoints.tabletXS)} {
    padding-bottom: 54px;
  }
`;

export const Container = styled.section`
  margin: 28px 0;
  padding: 60px 232px;
  background: ${COLORS.WHITE};
  box-shadow: 0px 1px 15px rgba(12, 37, 54, 0.15);
  border-radius: 15px;

  ${mediaMax(breakpoints.laptopS)} {
    padding: 60px 120px;
  }

  ${mediaMax(breakpoints.tabletM)} {
    padding: 60px;
  }

  ${mediaMax(breakpoints.tabletXS)} {
    padding: 15px;
    margin: 12px 0px 24px 0px;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${COLORS.FORM_ELEMENT_BORDER};

  ${mediaMax(breakpoints.tabletXS)} {
    align-items: flex-start;
    padding-bottom: 15px;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 32px;
  line-height: 130%;
  color: ${COLORS.PRIMARY_TEXT};

  ${mediaMax(breakpoints.tabletXS)} {
    font-size: 26px;
  }
`;

export const Subtitle = styled.h2`
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: ${COLORS.SECONDARY_TEXT};

  ${mediaMax(breakpoints.tabletXS)} {
    font-size: 12px;
  }
`;
